var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "7ywi1o2v6a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.611765 0 0 0 0 0.639216 0 0 0 0 0.678431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    filter: "url(#7ywi1o2v6a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-3.895a5.74 5.74 0 0 1 4.085 1.695.826.826 0 1 1-1.167 1.167A4.1 4.1 0 0 0 22 22.757a4.1 4.1 0 0 0-2.918 1.21.826.826 0 1 1-1.167-1.167A5.74 5.74 0 0 1 22 21.105zm0-3.302c2.425 0 4.706.946 6.422 2.663a.826.826 0 0 1-1.169 1.167A7.378 7.378 0 0 0 22 19.453c-1.984 0-3.85.775-5.254 2.18a.826.826 0 1 1-1.168-1.167A9.018 9.018 0 0 1 22 17.803zm0-3.303c3.308 0 6.418 1.29 8.758 3.632a.826.826 0 0 1-1.168 1.167A10.661 10.661 0 0 0 22 16.151a10.661 10.661 0 0 0-7.59 3.148.826.826 0 0 1-1.168-1.167A12.301 12.301 0 0 1 22 14.5z",
    fill: "#8793A3",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListNetwork);
export default __webpack_public_path__ + "static/media/ico-vpc-list-network.edd1ccbff74c39a90d4da0cd1c1ef5cc.svg";
export { ForwardRef as ReactComponent };